import { Loader } from '@googlemaps/js-api-loader'

const section = document.querySelector('.map-tile-section')


function markerClickHandler(map, marker, infoWindow, label) {
    infoWindow.setContent(label)
    infoWindow.open(map, marker)
}

function addMarkers(map) {

    const tiles = Array.from(section.querySelectorAll('.tile'))

    if (!tiles.length > 0) {
        console.warn('There are no tiles to generate markers.')
        return
    }

    const infoWindow = new google.maps.InfoWindow({
        content: '',
    })

    tiles.map(tile => {

        const position = {
            lat: parseFloat(tile.dataset.lat),
            lng: parseFloat(tile.dataset.lng),
        }

        const marker = new google.maps.Marker({
            position,
            map,
            icon: document.querySelector('#MAP_MARKER').value
        })

        const label = tile.dataset.title

        marker.addListener('click', () => {
            markerClickHandler(map, marker, infoWindow, label)
        })
    })
}

function setup() {

    const container = section.querySelector('.tile-group-map')

    const options = {
        center: {
            lat: -36.793,
            lng: 175.092
        },
        zoom: 12,
        mapId: document.querySelector('#MAP_ID').value
    }

    const map = new google.maps.Map(container, options)

    addMarkers(map)
}

export function main() {

    if (!section) {
        return
    }

    const container = section.querySelector('.tile-group-map')

    if (!container) {
        return
    }

    const API_KEY = container.dataset.key;

    if (!API_KEY) {
        throw 'Google maps will not work without an API_KEY'
    }

    const loader = new Loader({
        apiKey: API_KEY,
    })

    loader.load().then(setup)

}
